module.exports = __webpack_public_path__ + "img/mlbb.2804c5b.png";